import {Exclude, Type} from 'class-transformer';
import {serializeType} from './common';
import {DocumentType, Roles, Transaction} from '@app/shared';
import {ExpenseType} from "@app/finance/expense/expense-report";


export class DocAttribute {
  id: number;
  attrValue: string;
  attrName: string;
  subtype: string;
  attributeNameId: number;
  version: number;

  constructor(attributeNameId: number, attrName?: string, subtype?: string) {
    this.attributeNameId = attributeNameId;
    if (attrName) {
      this.attrName = attrName;
    }
    if (subtype) {
      this.subtype = subtype;
    }
  }
}

export enum FilePermissionType {
  Owner = 'OWNER',
  Approver = 'APPROVER',
  Role = 'ROLE',
}

export class FilePermission {
  role?: string;
  roleValue?: string;
  filePermissionType?: FilePermissionType;
  canRead: boolean;
  canWrite: boolean;
  canDelete: boolean;
  canPermit: boolean;
}

export enum FilePermissionSettingType {
  DefaultPermission = 'default',
  FilePermission = 'file'
}

export class DefaultPermissionSetting {
  id: number;
  version: number;
  orgId: number;
  transaction: string;
  @Type(serializeType(FilePermission)) permission: FilePermission = new FilePermission();
}

export class FilePermissionSetting {
  id: number;
  version: number;
  docFileId: number;
  @Type(serializeType(FilePermission)) permission: FilePermission = new FilePermission();
}

export class FileSecurityRoleConfig {
  id: number;
  version: number;
  orgId: number;
  transaction: string;
  role: string;
  className: string;
}

export class DocFile {
  id: number;
  version: number;
  fileName: string;
  mimeType: string;
  data: any[];
  refId: number;
  transaction: string;
  path: string;
  docTypeId: number;
  docFolderId: number;
  ownerId: number;
  docTypeName?: string;
  docFolderName?: string;
  systemGenerated?: boolean;
  createdOn: Date;
  modifiedOn: Date;
  updated?: boolean;          // used to filter out when saving to the backend

  @Type(serializeType(DocAttribute)) docAttributes?: Array<DocAttribute>;
  @Type(serializeType(FilePermissionSetting)) displayPermissionSettings?: Array<FilePermissionSetting>;

  //Transient Fields, populated in front end to show/hide options
  //TODO:  Configure @Exclude()/@jsonignore on application level so that, the transient fields can be removed from the backend
  @Exclude()
  permission: FilePermission;
}
